/*
 * Copyright © 2017-2026 Knowledge for Decisions (K4D). All rights reserved.
 *
 * This code and associated materials are protected by copyright laws and international
 * treaties. Unauthorized use, reproduction, distribution, or modification of any content
 * from Knowledge for Decisions (K4D) is strictly prohibited. For inquiries regarding
 * the use or licensing of K4D's copyrighted materials, please contact us at
 * contact@k4d.com.br. "Knowledge for Decisions (K4D)" and the slogan "Using data to make
 * precise decisions" are registered trademarks of Knowledge for Decisions (K4D).
 */

import { en } from './i18n-resources-en';
import { ptBR } from './i18n-resources-pt';
import { es } from './i18n-resources-es';

/**
 * All translation resources keyed by language and namespace.
 */
export const resources = {
  en,
  'pt-BR': ptBR,
  es,
};

/**
 * The list of all configured i18next namespaces.
 */
export const namespaces = Object.keys(resources.en);
